import { BKJCheckbox } from '@bookjane2/bookjane-design-library';
import styled, { css } from 'styled-components';

export const TextAlignCenter = styled.span`
  text-align: center;
`;

export const GroupName = styled.span`
  ${({ theme }) => theme.fonts.PoppinsBold};
`;

export const WithdrawCheckbox = styled(BKJCheckbox)`
  width: auto;
  height: auto;
  align-items: flex-start;

  label {
    ${({ theme }) => theme.typography.Caption};
    margin-left: 12px;
    color: ${({ theme }) => theme.colors.TextDarkGrey};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;

      label {
        cursor: not-allowed;
        color: ${({ theme }) => theme.colors.Grey4};
      }
    `};
`;
